import { HttpStatusCode } from 'data/protocols/http';
import {
  ConflictError,
  InvalidCredentialsError,
  NotFoundError,
  UnexpectedError,
} from 'domain/errors';
import { VerifyInternshipResponsibleCpfUseCaseInterface } from 'domain/usecases';

export class RemoteVerifyInternshipResponsibleCpf
  implements VerifyInternshipResponsibleCpfUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: VerifyInternshipResponsibleCpfUseCaseInterface.Params,
  ): Promise<VerifyInternshipResponsibleCpfUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFoundError(httpResponse.body.message);
      case HttpStatusCode.conflict:
        throw new ConflictError(httpResponse.body.message);
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
